function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

/**
 * Parse a time string into {h, m, s} where time can be:
 * - "HH:mm"
 * - "HH:mm:ss"
 */
function parseTime24(timeStr: string): { h: number; m: number; s: number } | null {
  const raw = timeStr.trim();
  const match = raw.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return null;
  const h = Number(match[1]);
  const m = Number(match[2]);
  const s = Number(match[3] ?? "0");
  if (![h, m, s].every((v) => Number.isFinite(v))) return null;
  if (h < 0 || h > 23 || m < 0 || m > 59 || s < 0 || s > 59) return null;
  return { h, m, s };
}

export function subtractMinutes(
  timeStr: string | null | undefined,
  minutesToSubtract: number
): string | null {
  if (!timeStr) return null;
  const parsed = parseTime24(String(timeStr));
  if (!parsed) return null;

  const daySeconds = 24 * 60 * 60;
  const total = parsed.h * 3600 + parsed.m * 60 + parsed.s;
  const next =
    ((total - minutesToSubtract * 60) % daySeconds + daySeconds) % daySeconds;

  const outH = Math.floor(next / 3600);
  const outM = Math.floor((next % 3600) / 60);
  const outS = next % 60;
  return `${pad2(outH)}:${pad2(outM)}:${pad2(outS)}`;
}

/**
 * Convert "HH:mm" or "HH:mm:ss" (24h) into "h:mm AM/PM".
 * Returns "—" if input is empty/invalid.
 */
export function toAmPm(timeStr: string | null | undefined): string {
  if (!timeStr) return "—";
  const parsed = parseTime24(String(timeStr));
  if (!parsed) return "—";
  const hour12 = ((parsed.h + 11) % 12) + 1;
  const ampm = parsed.h >= 12 ? "PM" : "AM";
  return `${hour12}:${pad2(parsed.m)} ${ampm}`;
}

